import { apiCall, filterParams } from '../helpers/axios';

class BidService {

	static getAuctionBids(auctionId, params) {
		return apiCall().get(`/auctions/${auctionId}/bids`, { params: params })
			.then(response => response.data);
	}

	static getAuctionPersonBids(auctionId, personId, params) {
		return apiCall().get(`/auctions/${auctionId}/person/${personId}/bids`, { params: params })
			.then(response => response.data);
	}

	static getAuctionBidNumberBids(auctionId, bidNumber, params, cancelToken) {
		return apiCall().get(`/auctions/${auctionId}/bid_number/${bidNumber}/bids`, { params: params, cancelToken: cancelToken })
			.then(response => response.data);
	}

}

export default BidService


// WEBPACK FOOTER //
// ./src/services/bid-service.js